import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { BASE_URL } from './BaseUrl';
import InnerHeader from './InnerHeader';
//import FormControlLabel from '@mui/material/FormControlLabel';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Corporate_Inquiry_Report from './Document/Corporate_Inquiry_Report';
import { pdf } from '@react-pdf/renderer';
import * as XLSX from "xlsx";


const CorporateRecord = () => {

    const [company, setCompany] = useState([])
    const [errors, setErrors] = useState({});
    const [course, setCourse] = useState([]);


    const [formData, setFormData] = useState({
        company: '',
        course: '',
        fromDate: '',
        toDate: '',
        purpose: '',
        followUpStatus: ''
    });


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleformdatechange = (date) => {
        const formattedDate = date.toISOString().split('T')[0];
        setFormData((prev) => ({ ...prev, fromDate: formattedDate }));
    };

    const handletodatechange = (date) => {
        const formattedDate = date.toISOString().split('T')[0];
        setFormData((prev) => ({ ...prev, toDate: formattedDate }));
    };





    const validateForm = () => {
        const newErrors = {};
        let isValid = true;

        if (!formData.company) {
            newErrors.company = "Company is required";
            isValid = false;
        }
        if (!formData.fromDate) {
            newErrors.fromDate = "From date is required";
            isValid = false;
        }
        if (!formData.toDate) {
            newErrors.toDate = "To date is required";
            isValid = false;
        }
        if (!formData.purpose && (formData.followUpStatus === 'Follow Up')) {
            newErrors.purpose = "Purpose is required";
            isValid = false;
        }
        if (!formData.course && (formData.followUpStatus !== 'Follow Up')) {
            newErrors.course = "Course is required";
            isValid = false;
        }
        if (!formData.followUpStatus) {
            newErrors.followUpStatus = "Follow-up status is required";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };



    async function getEmployeeData() {

        axios.get(`${BASE_URL}/getCompanies`)
            .then((res) => {
                setCompany(res.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }
    async function getCourse() {

        axios.get(`${BASE_URL}/getCourse`)
            .then((res) => {
                setCourse(res.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }


    useEffect(() => {
        getCourse()
        getEmployeeData()
    }, [])



    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        try {
            const res = await axios.post(`${BASE_URL}/getcorporaterecordexcel`, formData);
            const data = res.data;


            if(formData.followUpStatus == 'Follow Up'){

                followToExcel(data, formData.fromDate, formData.toDate)
            }
            else{
                exportToExcel(data, formData.fromDate, formData.toDate)
            }



        } catch (err) {
            console.error("Error generating Excel:", err);
        }
    };


    const followToExcel = (data, fromDate, toDate) => {
        // Title row
        const title = [
            [`Corporate Record Report (FollowUp) from : ${fromDate} To ${toDate}`],
        ];
        // Header row (your columns)
        const headers = [
            [
                "Date",
                "Discipline",
                "Company Name",
                "Contact Person",
                "Mobile",
                "E-mail",
                "DirectLine",
                "Designation",
                "Purpose",
                "remark",
                "WebSite",
                "Mobile1",
                "Status",
            ],
        ];

        // Data rows
        const rows = data.map(item => [
            item.Date || "",
            item.Discipline || "",
            item.CompanyName || "",
            item.ContactPerson || "",
            item.Mobile || "",
            item.Email || "",
            item.DirectLine || "",
            item.Designation || "",
            item.Purpose || "",
            item.Remark || "",
            item.WebSite || "",
            item.Mobile1 || "",
            item.Status || "", // or just item.Status if it's already string
        ]);

        // Combine all parts
        const sheetData = [...title, [], ...headers, ...rows];

        // Convert to worksheet
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

        // Merge title across all 13 columns (A1:M1)
        worksheet["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: 12 } },
        ];

        // Adjust column widths
        worksheet["!cols"] = [
            { wch: 12 },  // Date
            { wch: 20 },  // Discipline
            { wch: 30 },  // Company Name
            { wch: 25 },  // Contact Person
            { wch: 15 },  // Mobile
            { wch: 30 },  // Email
            { wch: 15 },  // DirectLine
            { wch: 15 },  // Designation
            { wch: 15 },  // Purpose
            { wch: 50 },  // Remark
            { wch: 25 },  // WebSite
            { wch: 15 },  // Mobile1
            { wch: 10 },  // Status
        ];

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "CorporateReport");

        // Write file buffer
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        // Create blob and download
        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `Corporate_Record_${Date.now()}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    
    const exportToExcel = (data, fromDate, toDate) => {
        // Title row
        const title = [
            [`Corporate Record Report (CvSend) from : ${fromDate} To ${toDate}`],
        ];
        // Header row (your columns)
        const headers = [
            [
                "Date",
                "Discipline",
                "BatchNo",
                "CandidateName",
                "CompanyName",
                "Remark",
            ],
        ];

        // Data rows
        const rows = data.map(item => [
            item.Date || "",
            item.Discipline || "",
            item.BatchNo || "",
            item.CandidateName || "",
            item.CompanyName || "",
            item.Remark || "",
        ]);

        // Combine all parts
        const sheetData = [...title, [], ...headers, ...rows];

        // Convert to worksheet
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

        // Merge title across all 13 columns (A1:M1)
        worksheet["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: 12 } },
        ];

        // Adjust column widths
        worksheet["!cols"] = [
            { wch: 12 },  // Date
            { wch: 20 },  // Discipline
            { wch: 30 },  // Company Name
            { wch: 25 },  // Contact Person
            { wch: 15 },  // Mobile
            { wch: 30 },  // Email
            { wch: 15 },  // DirectLine
            { wch: 15 },  // Designation
            { wch: 15 },  // Purpose
            { wch: 50 },  // Remark
            { wch: 25 },  // WebSite
            { wch: 15 },  // Mobile1
            { wch: 10 },  // Status
        ];

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "CorporateReport");

        // Write file buffer
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        // Create blob and download
        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `Corporate_Record_${Date.now()}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };




    // const Blob = async (data) => {

    //     try {

    //         const blob = await pdf(<Corporate_Inquiry_Report data={data} />).toBlob();

    //         const url = URL.createObjectURL(blob);

    //         // Display PDF in a new tab
    //         window.open(url);



    //         // Clean up the object URL
    //         URL.revokeObjectURL(url);
    //     } catch (err) {
    //         console.error("Error generating PDF:", err);
    //     }


    // };





    return (

        <div className="container-fluid page-body-wrapper ">
            <InnerHeader />
            <div className="main-panel">
                <div className="content-wrapper">
                    <div className="row">
                        <div className="col-lg-12 grid-margin stretch-card">
                            <div className="card">
                                <div className="card-body">
                                    <h4 className="card-title">Corporate Inquiry</h4>
                                    <hr></hr>
                                    <form className="forms-sample py-3" onSubmit={handleSubmit}>
                                        <div className='row'>


                                            <div className="form-group col-lg-3">
                                                <label for="exampleFormControlSelect1">Select Company<span className='text-danger'>*</span> </label>
                                                <select className="form-control form-control-lg" onChange={handleInputChange} id="exampleFormControlSelect1" name='company'>
                                                    <option >Select Company</option>
                                                    <option value={'All'}>All</option>
                                                    {company.map((item, index) => {
                                                        return (
                                                            <option value={item.CompanyName} key={index} >{item.CompanyName}</option>
                                                        )
                                                    })}
                                                </select>
                                                {errors.company && <span className='text-danger'>{errors.company}</span>}
                                            </div>




                                            <div className="form-group col-lg-3" style={{ display: 'flex', flexDirection: "column" }}>
                                                <label for="exampleInputUsername1">From Date<span className='text-danger'>*</span></label>
                                                <DatePicker
                                                    selected={formData.fromDate}
                                                    onChange={handleformdatechange}
                                                    className="form-control"
                                                    id="exampleInputUsername1"
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Select From Date"
                                                />
                                                {errors.fromDate && <span className='text-danger'>{errors.fromDate}</span>}
                                            </div>

                                            <div className="form-group col-lg-3" style={{ display: 'flex', flexDirection: "column" }}>
                                                <label for="exampleInputUsername1">To Date<span className='text-danger'>*</span></label>
                                                <DatePicker
                                                    selected={formData.toDate}
                                                    onChange={handletodatechange}
                                                    className="form-control"
                                                    id="exampleInputUsername1"
                                                    dateFormat="dd-MM-yyyy"
                                                    placeholderText="Select To Date"
                                                />
                                                {errors.toDate && <span className='text-danger'>{errors.toDate}</span>}
                                            </div>

                                            {formData.followUpStatus == 'Follow Up' ? <div className="form-group col-lg-3">
                                                <label for="exampleFormControlSelect1">Select Purpose<span className='text-danger'>*</span> </label>
                                                <select className="form-control form-control-lg" id="exampleFormControlSelect1" name='purpose' onChange={handleInputChange}>
                                                    <option>Select Purpose</option>
                                                    <option value="All">All</option>
                                                    <option value="Meeting">Meeting</option>
                                                    <option value="Others">Others</option>
                                                    <option value="Placement">Placement</option>
                                                    <option value="Placement Received">Placement Received</option>
                                                    <option value="Project">Project</option>
                                                    <option value="Proposal">Proposal</option>
                                                    <option value="Seminar">Seminar</option>
                                                    <option value="Sponsership- stall">Sponsership- stall</option>
                                                    <option value="Training">Training</option>
                                                    <option value="Training Received">Training Received</option>

                                                </select>

                                                {errors.purpose && <span className='text-danger'>{errors.purpose}</span>}
                                            </div> :           <div className="form-group col-lg-3">
                                                <label for="exampleFormControlSelect1">Select Course<span className='text-danger'>*</span> </label>
                                                <select className="form-control form-control-lg" onChange={handleInputChange} id="exampleFormControlSelect1" name='course'>
                                                    <option >Select Course</option>
                                                    <option value={'All'}>All</option>
                                                    {course.map((item, index) => {
                                                        return (
                                                            <option value={item.Course_Id} key={index} >{item.Course_Name}</option>
                                                        )
                                                    })}
                                                </select>
                                                {errors.course && <span className='text-danger'>{errors.course}</span>}
                                            </div>}

                                           

                                  

                                        </div>



                                        <div
                                            className="d-flex justify-content-between flex-wrap gap-3 p-3 border rounded shadow-sm"
                                            style={{ width: '100%', maxWidth: '700px', backgroundColor: '#f9f9f9' }}
                                        >
                                            {['Follow Up', 'CV Send', 'Candidate Shortlisted', 'Candidate Placed'].map((label, index) => (
                                                <div key={index} className="form-check d-flex align-items-center gap-2">
                                                    <input
                                                        type="radio"
                                                        onChange={handleInputChange}
                                                        style={{ width: "50px", cursor: "pointer" }}
                                                        className="form-check-input"
                                                        name="followUpStatus"
                                                        id={`followup-${index}`}
                                                        value={label}
                                                    />
                                                    <label className="form-check-label mb-0" htmlFor={`followup-${index}`}>
                                                        {label}
                                                    </label>
                                                </div>
                                            ))}

                                            {errors.followUpStatus && <span className='text-danger'>{errors.followUpStatus}</span>}
                                        </div>


                                        <button type="submit" className="btn btn-primary mr-2">Excel</button>
                                        <button type='button' onClick={() => {
                                            window.location.reload()
                                        }} className="btn btn-primary">Back</button>



                                    </form>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div >
        </div >

    )
}

export default CorporateRecord;
